import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Marks a projected <ng-template> as the custom cell renderer for a column.
 *
 *   <ng-template appColumnCell="actions" let-row let-index="index">...</ng-template>
 *
 * The data-table matches the directive's name against a column's `templateName`.
 */
@Directive({
  selector: '[appColumnCell]',
  standalone: false
})
export class ColumnCellDirective {
  /** Name that links this template to a column (ColumnDef.templateName). */
  @Input('appColumnCell') name: string;

  constructor(public template: TemplateRef<any>) { }
}
